import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { cn } from "@/lib/utils";
import { Cpu, HardDrive, CircuitBoard, Activity } from "lucide-react";

interface SystemMetric {
  name: string;
  value: number;
  icon: any;
  color: string;
}

interface SystemStatusCardProps {
  metrics: {
    cpu: number;
    memory: number;
    disk: number;
    uptime: string;
  };
  className?: string;
}

export function SystemStatusCard({ metrics, className }: SystemStatusCardProps) {
  const systemMetrics: SystemMetric[] = [
    { name: 'CPU', value: metrics.cpu, icon: Cpu, color: 'bg-blue-500' },
    { name: 'Memory', value: metrics.memory, icon: CircuitBoard, color: 'bg-green-500' },
    { name: 'Disk', value: metrics.disk, icon: HardDrive, color: 'bg-yellow-500' },
  ];

  return (
    <Card className={className}>
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <span>Sistem Durumu</span>
          <div className="flex items-center gap-2 text-sm font-normal text-muted-foreground">
            <Activity className="w-4 h-4 text-green-500" />
            {metrics.uptime}
          </div>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {systemMetrics.map((metric) => (
            <div key={metric.name} className="space-y-2">
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <div className={cn(
                    "p-2 rounded-lg",
                    "bg-background/50",
                    "border border-border"
                  )}>
                    <metric.icon className="w-4 h-4" />
                  </div>
                  <span className="font-medium">{metric.name}</span>
                </div>
                <span className="text-sm font-medium">
                  {metric.value}%
                </span>
              </div>
              <div className="h-2 w-full bg-muted/30 rounded-full overflow-hidden">
                <div
                  className={cn("h-full rounded-full transition-all duration-500", metric.color)}
                  style={{ width: `${metric.value}%` }}
                />
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
}
